import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { environment } from "../../../environments/environment";

export interface Carta {
  descripcion: string;
  id?: number;
  titulo: string;
  contenido: string;
  fecha?: string;  // o el tipo de campo que tengas en la BD
}
export interface Vehiculo {
  propietario: any;
  tipoCombustible: any;
  tipoVehiculo: any;
  marcas: any;
  tipoRelacion: any;
  placa: string;
  clase: string;
  marca: string;
  modelo: string;
  capacidad: string;
  chasis: string;
  motor: string;
  servicio: string;
  combustible: string;
  Idpropietario: number;
}

export interface Bloque {
  id: number;
  bloque: number;
  descripcion: string;
  estado: number;
}

export interface DatosVehiculoCarta {
  administracion: any;
  vehiculo: Vehiculo;
  carta: Carta;
  bloques: Bloque[];
}


@Injectable({
  providedIn: "root",
})
export class CartasService {
  private apiUrl = `${environment.apiUrl}/api/cartas`;

  constructor(private http: HttpClient) {}

  // Crear una nueva carta
  createCarta(carta: Carta): Observable<Carta> {
    return this.http.post<Carta>(this.apiUrl, carta, { withCredentials: true })
      .pipe(
        catchError((error) => {
          const message = error.error?.message || "Error al crear carta.";
          return throwError(() => new Error(message));
        })
      );
  }

  // Obtener todas las cartas
  getAllCartas(): Observable<Carta[]> {
    return this.http.get<Carta[]>(this.apiUrl, { withCredentials: true })
      .pipe(
        catchError((error) => {
          const message = error.error?.message || "Error al obtener cartas.";
          return throwError(() => new Error(message));
        })
      );
  }

  // Obtener una carta por ID
  getCartaById(id: number): Observable<Carta> {
    return this.http.get<Carta>(`${this.apiUrl}/${id}`, { withCredentials: true })
      .pipe(
        catchError((error) => {
          const message = error.status === 404
            ? "Carta no encontrada."
            : error.error?.message || "Error al obtener carta.";
          return throwError(() => new Error(message));
        })
      );
  }

  // Actualizar una carta por ID
  updateCarta(id: number, carta: Carta): Observable<Carta> {
    return this.http.put<Carta>(`${this.apiUrl}/${id}`, carta, { withCredentials: true })
      .pipe(
        catchError((error) => {
          const message = error.status === 404
            ? "Carta no encontrada."
            : error.error?.message || "Error al actualizar carta.";
          return throwError(() => new Error(message));
        })
      );
  }

  // Eliminar una carta por ID
  deleteCarta(id: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${id}`, { withCredentials: true })
      .pipe(
        catchError((error) => {
          const message = error.status === 404
            ? "Carta no encontrada."
            : error.error?.message || "Error al eliminar carta.";
          return throwError(() => new Error(message));
        })
      );
  }
  
 getDatosVehiculoCarta(data: {
    placa: string;
    id: number;
    nombreEmpresa?: string | null;
    ciudadEmpresa?: string | null;
    porcentajeEmpresa?: string | null;
    valorEmpresa?: string | null;
  }): Observable<DatosVehiculoCarta> {
    return this.http
      .post<DatosVehiculoCarta>(`${this.apiUrl}/placa`, data, {
        withCredentials: true,
      })
      .pipe(
        catchError((error) => {
          const message =
            error.error?.message ||
            "Error al obtener datos de vehículo y carta.";
          return throwError(() => new Error(message));
        })
      );
  }
}

